module.exports = __webpack_public_path__ + "static/media/BlackDesperado.0fa7da4e.jpg";